<template>
    <div>
    <div class="w-full">
            <label for="phone">{{ step.label }}</label>
            <input
                @input="updateParentValue"
                v-model.trim="inputData"
                class="input-styling"
                :placeholder="step.placeholder"
            />
        </div>
        <div class="error-text-styling">
            <div v-if="displayErrorMessage">
                {{step.errorMessage}}
            </div>
        </div>
    </div>
            
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    props: ['step', 'value'],
    data() {
      return {
        dirty: false,
        inputData: ''
      }
    },
    validations: {
        inputData: {
            required,
            validPhone (value) {
                return this.isValidInput(value)
            },
            uniqueCharacterLimit (value) {
                return this.countUniqueCharacters(value) > 3;
            }
        }
    },
    computed: {
        displayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        }
    },
    methods: {
        countUniqueCharacters(characters) {
            return characters.split('').filter(function(item, i, ar){ return ar.indexOf(item) === i; }).join('').length;
        },
        isValidInput(value) {
            const numWithoutSpaces = value.replace(/\s/g, '');

            return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(numWithoutSpaces);
        },

        updateParentValue(){
            this.dirty = true;
            this.$emit("input", {'value': this.inputData, 'valid': !this.$v.inputData.$invalid})            
        }
    }
}
</script>

<style lang="scss" scoped>
</style>